import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from "@angular/forms";
import {LovValueSummary} from "../../../../common/lov/lov-value/api/model/lovValueSummary.model";

@Component({
  selector: 'app-person-title-select-filter',
  templateUrl: './person-title-select-filter.component.html'
})
export class PersonTitleSelectFilterComponent implements OnInit {

  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;

  @Output() singleSelectionChangedEvent: EventEmitter<LovValueSummary> = new EventEmitter();

  constructor() { }

  ngOnInit() {}

}
